import { isGDPRCountry } from '@mc/gdpr'
import { getGeo } from '@mc/geo'
import { userHasGivenGdprPermission } from './userHasGivenGdprPermission'

export const canSaveUserData = () =>
  !isGDPRCountry(getGeo()) || userHasGivenGdprPermission()
